module.exports = __webpack_public_path__ + "img/success_icon.422f8b1e.png";